import type { AxiosResponse } from "axios";
import { ApiInstance } from "@/api";
import type {
  CustomCategoryDto,
  CustomCategoryUpdateSubCatDto,
  CustomCategoryCreateDto,
} from "@/api/classes/customCategories/customCategories.dto";
import type {
  WbNomenclatureCharacteristicDto,
  OzonAttribute,
} from "@/types/product/productTypes";

export default class CUSTOMCATEGORIES_API {
  static async getCustomCategories(): Promise<
    AxiosResponse<CustomCategoryDto[]>
  > {
    return ApiInstance.get<CustomCategoryDto[]>("/CustomCategories/Categories");
  }

  static async getCustomCategory(
    categoryId: string,
  ): Promise<AxiosResponse<CustomCategoryDto>> {
    return ApiInstance.get<CustomCategoryDto>(
      `/CustomCategories/Category/${categoryId}`,
    );
  }

  static async postCustomCategory(
    category: CustomCategoryCreateDto,
  ): Promise<AxiosResponse<CustomCategoryDto>> {
    return ApiInstance.post<CustomCategoryDto>("/CustomCategories", category);
  }

  static async deleteCustomCategory(
    categoryId: string,
  ): Promise<AxiosResponse> {
    return ApiInstance.delete(`/CustomCategories/Delete/${categoryId}`);
  }

  static async updateNameCustomCategory(
    categoryId: string,
    newName: string,
  ): Promise<AxiosResponse> {
    return ApiInstance.patch(
      `/CustomCategories/${categoryId}/Name?newName=${newName}`,
    );
  }

  static async updateWbCharacteristicsCustomCategory(
    categoryId: string,
    characteristics: WbNomenclatureCharacteristicDto[],
    sizesOn: boolean,
    tnvd: string,
  ): Promise<AxiosResponse> {
    return ApiInstance.patch(
      `/CustomCategories/Characteristics/${categoryId}?sizesOn=${sizesOn}&tnvd=${tnvd}`,
      characteristics,
    );
  }

  static async updateOzonCharacteristicsCustomCategory(
    categoryId: string,
    characteristics: OzonAttribute[],
    sizesOn: boolean,
  ): Promise<AxiosResponse> {
    return ApiInstance.patch(
      `/CustomCategories/OzonCharacteristics/${categoryId}?sizesOn=${sizesOn}`,
      characteristics,
    );
  }

  static async updateSubCategoryCustomCategory(
    categoryId: string,
    data: CustomCategoryUpdateSubCatDto,
  ): Promise<AxiosResponse> {
    return ApiInstance.patch(
      `/CustomCategories/ChangeCategory/${categoryId}`,
      data,
    );
  }

  static async importCustomCategories(
    options = {
      addCharacteristics: false,
      addWb: false,
      addOzon: false,
    },
  ): Promise<AxiosResponse> {
    return ApiInstance.post(
      `/CustomCategories/Import?addCharacteristics=${options.addCharacteristics}&addWb=${options.addWb}&addOzon=${options.addOzon}`,
    );
  }
}
